const MODULE_NAME = 'UsersModule';

export const GET_CURRENT_USER = `${MODULE_NAME}/GET_CURRENT_USER`;
export const GET_ROLES = `${MODULE_NAME}/GET_ROLES`;
export const GET_USERS = `${MODULE_NAME}/GET_USERS`;
export const GET_USERS_PENDING_APPROVAL = `${MODULE_NAME}/GET_USERS_PENDING_APPROVAL`;
export const GET_USERS_LOGGED_IN_TODAY = `${MODULE_NAME}/GET_USERS_LOGGED_IN_TODAY`;
export const GET_USERS_REJECTED = `${MODULE_NAME}/GET_USERS_REJECTED`;
export const GET_USERS_WITHOUT_SEPIA_INFO = `${MODULE_NAME}/GET_USERS_WITHOUT_SEPIA_INFO`;
